import React from "react";
import CollapsibleMessage from "../CollapsibleMessage";

const FinalDocContent = ({
  msg,
  messageId,
  initialExpanded,
  onToggle,
  preprocessContent,
  renderMermaidContent,
  renderCopyButton,
  styles,
}) => {
  const processedContent = preprocessContent(msg.context);
  return (
    <div className={`message-content-wrapper ${styles.messageContentWrapper || ""}`}>
      <CollapsibleMessage
        messageId={messageId}
        initialExpanded={initialExpanded}
        onToggle={onToggle}
        content={
          <div className={styles.expertMessage}>
            {renderMermaidContent(processedContent)}
          </div>
        }
      />
      {renderCopyButton(processedContent)}
    </div>
  );
};

export default React.memo(FinalDocContent);
